import { ReactElement } from 'react'

export function UnreadBadge({ value }: { value: number }): ReactElement {
  return value > 0 ? (
    <div
      className="flex h-5 shrink-0 items-center rounded border border-red-50 px-1.5 text-center"
      style={{ backgroundColor: `rgba(255, 90, 0, 0.08)`, borderColor: `rgba(0, 0, 0, 0.10)` }}
    >
      <span className="text-xs font-medium leading-[15px]" style={{ color: `#A72900` }}>
        {value} Unread
      </span>
    </div>
  ) : (
    <></>
  )
}
